import {Avatar, AvatarFallback} from "../basic/avatar";
import {Button} from "../basic/button";
import {getDisplayName, getInitials} from "../../utils/nameUtils.ts";
import {useTranslationWithKeys} from "../../hooks/useTranslationWithKeys";

interface UserInfoProps {
    user: any;
    onNavigate?: (path: string) => void;
}

export function UserInfo({user, onNavigate}: UserInfoProps) {
    const {t} = useTranslationWithKeys();
    return (
        <Button
            variant="ghost"
            onClick={() => onNavigate?.("/settings")}
            className="flex items-center gap-3 w-full justify-start text-left p-2"
        >
            <Avatar>
                <AvatarFallback>
                    {getInitials(user)}
                </AvatarFallback>
            </Avatar>
            <div className="flex-1 min-w-0">
                <p className="truncate" title={getDisplayName(user)}>{getDisplayName(user)}</p>
                <p className="text-muted-foreground truncate">
                    {user?.roles?.[0] ? t(`common.role.${user.roles[0].toLowerCase()}`) : t('common.role.user')}
                </p>
            </div>
        </Button>
    );
}